import { v4QuoterAbi } from './chunk-OAUUC2IW.mjs';
import { createDrift } from '@delvtech/drift';

var ReadQuoter = class {
  /**
   * Create a ReadQuoter instance
   * @param quoteV2Address - Contract address of the V4 Quoter
   * @param drift - Drift instance for blockchain interaction (defaults to new instance)
   */
  constructor(quoteV4Address, drift = createDrift()) {
    this.quoter = drift.contract({
      abi: v4QuoterAbi,
      address: quoteV4Address
    });
  }
  /**
   * Get a price quote for swapping an exact amount of input tokens
   * @param params - Arguments for the quoteExactInputSingle contract method
   * @param options - Formatting options for the output amount, defaults to 18 decimals
   * @returns Promise resolving to:
   * - Raw contract return values
   */
  async quoteExactInputV4(params) {
    return await this.quoter.simulateWrite("quoteExactInputSingle", {
      params: { ...params }
    });
  }
  /**
   * Get a price quote for receiving an exact amount of output tokens
   * @param params - Arguments for the quoteExactOutputSingle contract method
   * @param options - Formatting options for the input amount, defaults to 18 decimals
   * @returns Promise resolving to:
   * - Raw contract return values
   */
  async quoteExactOutputV4(params) {
    return await this.quoter.simulateWrite("quoteExactOutputSingle", {
      params: { ...params }
    });
  }
};

export { ReadQuoter };
//# sourceMappingURL=chunk-KG4FXD7S.mjs.map
//# sourceMappingURL=chunk-KG4FXD7S.mjs.map